import { type Common } from './common.js';
import { type PaginatedQueryOptions, type PaginationResponse } from './models/pagination/index.js';
import {
  type CreateValues,
  type FindAllOptions,
  type RecommendationTemplate,
  type RecommendationTemplatePopulated,
  type UpdateValues,
} from './models/recommendationTemplate.js';

export class API {
  common: Common;
  baseEndpoint: string;

  constructor(common: Common) {
    this.common = common;
    this.baseEndpoint = '/recommendation-templates';
  }

  async findAll(options: FindAllOptions = {}): Promise<RecommendationTemplatePopulated[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findAllPaginated(
    options: PaginatedQueryOptions<FindAllOptions>
  ): Promise<PaginationResponse<RecommendationTemplatePopulated>> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<RecommendationTemplate> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<RecommendationTemplate> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async update(id: string, values: UpdateValues): Promise<RecommendationTemplate> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.patchJSON(url, values);
  }

  async delete(id: string): Promise<{ success: boolean }> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.deleteJSON(url);
  }
}
